import {nodeFromString} from "../tools/NodeFromString";
import axios from "axios";

export default class CustomSearchInput {
    options = []
    disabled = false

    constructor(input, config = {}) {
        input.hidden = true;
        input.style.display = 'none';

        this.initArgument(input)
        this.initConfig(input, config)
        this.create(input)
    }

    initArgument(input) {
        this.input = {
            element: input,
            set value(value) {
                this.element.value = value
                this.element.dispatchEvent(new Event('change'))
            },
            get value() {
                return this.element.value;
            }
        }
    }

    initConfig(input, config = {}) {
        let defaultConfig = {
            data: {},
            class: 'dropdown',
            openedClass: 'active',
            panel: {
                class: 'dropdown-head',
            },
            dropdown: {
                class: 'dropdown-options',
            },
            options: {
                class: 'dropdown-option',
                chosenClass: 'active',
                promptClass: 'prompt'
            },
        }

        this.config = Object.assign(defaultConfig, {
            disabled: input.hasAttribute('disabled'),
            placeholder: input.getAttribute('placeholder'),
            prompt: input.getAttribute('prompt'),
            url: input.getAttribute('url'),
        }, config)

        if (input.hasAttribute('data-class')) {
            this.config.class += ' ' + input.getAttribute('data-class')
        }
    }

    renderOption(option) {
        let classes = [this.config.options.class]

        if (!option.value) {
            classes.push(this.config.options.promptClass)
        }
        if (option.value && option.selected) {
            classes.push(this.config.options.chosenClass)
        }

        return nodeFromString(`<li class="${classes.join(' ')}" tabindex="0">${option.label}</li>`)
    }

    renderSelect() {
        return nodeFromString(`
            <div class="${this.config.class} dropdown_has-search">
               <div class="${this.config.panel.class}">
                    <input class="input-search" placeholder="${this.config.placeholder ?? ''}" />
               </div>
                <ul class="${this.config.dropdown.class}"></ul>
            </div>
        `)
    }

    createSelect() {
        this.customSearchInput = this.renderSelect()
        this.customSearchInput.input = this.customSearchInput.querySelector('.' + this.config.panel.class + ' input')
        this.customSearchInput.panel = this.customSearchInput.querySelector('.' + this.config.panel.class)
        this.customSearchInput.dropdown = this.customSearchInput.querySelector('.' + this.config.dropdown.class)

        this.placeholder = {
            element: this.customSearchInput.input,
            set value(placeholder) {
                this.element.value = placeholder
            },
            get value() {
                return this.element.value
            }
        }

        this.customSearchInput.panel.addEventListener('click', () => {
            this.options.length && this.toggle()
        })

        this.customSearchInput.input.addEventListener('input', () => {
            this.loadOptions()
        })

        this.customSearchInput.input.addEventListener('change', () => {
            if (!this.customSearchInput.input.value) {
                this.reset()
            }
        })

        document.addEventListener('click', event => {
            if (this.isOpened() && !this.customSearchInput.contains(event.target)) {
                this.close()
            }
        })

        document.addEventListener('keydown', event => {
            switch (event.key) {
                case 'Enter':
                    if (this.customSearchInput.input === document.activeElement) {
                        event.preventDefault()
                        this.toggle()
                    }
                    break;
                case 'ArrowUp':
                    if (this.isOpened()) {
                        event.preventDefault()
                        this.focus('prev')
                    }
                    break;
                case 'ArrowDown':
                    if (this.isOpened()) {
                        event.preventDefault()
                        this.focus('next')
                    }
                    break;
                case 'Escape':
                    if (this.isOpened()) {
                        event.preventDefault()
                        this.close()
                    }
            }
        })
    }

    createOption(option) {
        option.element = this.renderOption(option)
        option.element.addEventListener('click', () => this.choose(option))
        option.element.addEventListener('keydown', event => {
            if (event.key === 'Enter') {
                event.preventDefault()
                this.choose(option)
            }
        })
    }

    open() {
        !this.disabled && this.customSearchInput.classList.add(this.config.openedClass)
    }

    close() {
        this.customSearchInput.classList.remove(this.config.openedClass)
    }

    toggle() {
        this.isOpened() ? this.close() : this.open()
    }

    isOpened() {
        return this.customSearchInput.classList.contains(this.config.openedClass)
    }

    loadOptions(page = null, openAfter = true) {
        let search = this.customSearchInput.input.value
        let data = typeof this.config.data === 'function' ? this.config.data() : this.config.data;

        axios.get(this.config.url, {params: Object.assign(data, {title: search})})
            .then(result => {
                let response = result.data
                if (response.success) {
                    this.options = response.data.map(item => {
                        return {
                            value: item.id,
                            label: item.title,
                        }
                    })

                    if (page === null) {
                        this.clearOptions()
                    }
                    if (this.options.length) {
                        this.appendOptions()
                        openAfter && this.open()
                    }
                }
            })
            .catch(() => {
            })

    }

    focus(key) {
        let focused = this.options.findIndex(option => option.element === document.activeElement) ?? 0,
            focusByIndex = index => {
                this.options[index]?.element.focus()
            },
            focusPrev = () => {
                focusByIndex(focused > 0 ? focused - 1 : focused)
            },
            focusNext = () => {
                focusByIndex(focused + 1)
            }

        switch (key) {
            case 'prev':
                focused === 0 ? this.customSearchInput.input.focus() : focusPrev()
                break;
            case 'next':
                focusNext()
                break;
            case Number.isInteger(key):
                focusByIndex(key)
                break;
            default:
                this.customSearchInput.input.focus()
        }
    }

    choose(option, focus = true) {
        this.options.forEach(option => option.element.classList.remove(this.config.options.chosenClass))
        option.value && option.element.classList.add(this.config.options.chosenClass)
        this.chosenOption = option
        this.placeholder.value = option.label
        this.input.value = option.value
        this.close()
        focus && setTimeout(() => this.focus(), 10)
    }

    clearOptions() {
        this.customSearchInput.dropdown.innerHTML = ''
    }

    appendOptions() {
        this.customSearchInput.dropdown.append(...this.options.map(option => {
            this.createOption(option)
            return option.element
        }))
    }

    create(input) {
        this.createSelect()
        this.appendOptions()
        input.after(this.customSearchInput)

        if (input.dataset.value) {
            this.placeholder.value = input.dataset.value
        }
    }

    reset() {
        this.input.value = ''
        this.placeholder.value = ''
        this.clearOptions()
        this.close()
    }

    disable() {
        this.customSearchInput.input.setAttribute('disabled', 'disabled')
        this.disabled = true
        this.close()
    }

    enable() {
        this.customSearchInput.input.removeAttribute('disabled')
        this.disabled = false
    }
}

document.querySelectorAll('[custom-search-input]').forEach(input => new CustomSearchInput(input))




